import { useEffect } from "react";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import Differentials from "@/components/Differentials";
import MapSection from "@/components/MapSection";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";

function App() {
  useEffect(() => {
    const hide = () => {
      const el = document.getElementById('emergent-badge');
      if (el) el.remove();
    };
    hide();
    const iv = setInterval(hide, 200);
    const obs = new MutationObserver(hide);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => { clearInterval(iv); obs.disconnect(); };
  }, []);

  return (
    <div data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Gallery />
        <Reviews />
        <Differentials />
        <MapSection />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}

export default App;
